import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { getUrlWithParams } from 'core-components/helpers/url'

import {
  NEW_VIEW_MODE_URL_PARAM_VALUE,
  OLD_VIEW_MODE_URL_PARAM_VALUE,
  VIEW_MODE_URL_PARAM_KEY,
} from './viewModeUrlParam'

export const useSwitchViewMode = (paramKey = VIEW_MODE_URL_PARAM_KEY) => {
  const navigate = useNavigate()

  return useCallback(
    (nextViewMode: 'old' | 'new') => {
      navigate(
        getUrlWithParams({
          [paramKey]:
            nextViewMode === 'new' ? NEW_VIEW_MODE_URL_PARAM_VALUE : OLD_VIEW_MODE_URL_PARAM_VALUE,
        })
      )
    },
    [navigate, paramKey]
  )
}
